import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const WordProblemAdventure = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [problemsSolved, setProblemsSolved] = useState(0);

  const wordProblems = [
    {
      story: "Sarah has 24 candies. She wants to share them equally among 4 friends. How many candies does each friend get?",
      answer: 6
    },
    {
      story: "A book costs NRs. 1250 and a pen costs NRs. 325. How much do they cost together?",
      answer: 1575
    },
    {
      story: "Tom ran 3.5 km on Monday and 2.8 km on Tuesday. How many km did he run in total?",
      answer: 6.3
    },
    {
      story: "A rectangle has a length of 8 cm and width of 5 cm. What is its perimeter?",
      answer: 26
    },
    {
      story: "Emma bought 3 notebooks at NRs. 250 each. How much did she spend?",
      answer: 750
    },
    {
      story: "A pizza is cut into 8 equal slices. If you eat 3 slices, what fraction of the pizza did you eat?",
      answer: 0.375 // 3/8
    },
    {
      story: "A car travels 60 km per hour. How far will it travel in 3 hours?",
      answer: 180
    },
    {
      story: "A box contains 144 chocolates. If they are packed in boxes of 12, how many boxes are there?",
      answer: 12
    },
    {
      story: "The temperature was 25°C in the morning and rose by 8°C. What is the temperature now?",
      answer: 33
    },
    {
      story: "A garden is 15 meters long and 8 meters wide. What is its area in square meters?",
      answer: 120
    },
    {
      story: "If 5 apples cost NRs. 750, how much does one apple cost?",
      answer: 150
    },
    {
      story: "A water tank holds 500 liters. If 275 liters are used, how much water is left?",
      answer: 225
    }
  ];

  const generateQuestion = () => {
    const q = wordProblems[Math.floor(Math.random() * wordProblems.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = parseFloat(userAnswer);
    if (Math.abs(answer - question.answer) < 0.01) {
      setScore(score + 20);
      setProblemsSolved(problemsSolved + 1);
      setFeedback('✅ Excellent!');
      setTimeout(generateQuestion, 2000);
    } else {
      setFeedback(`❌ Not quite! Answer: ${question.answer}`);
      setTimeout(generateQuestion, 3000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-600 via-teal-600 to-blue-600 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-300">← Back</button>
            <h1 className="text-3xl font-bold">📚 Word Problem Adventure</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🧩</div>
            <h2 className="text-2xl font-bold text-gray-800">Solve Real-World Problems!</h2>
            <p className="text-gray-600">Problems Solved: {problemsSolved}</p>
          </div>

          {question && (
            <div>
              <div className="bg-blue-50 rounded-lg p-6 mb-6">
                <p className="text-lg text-gray-800 leading-relaxed">{question.story}</p>
              </div>

              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <input
                  type="number"
                  step="0.01"
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="w-full text-3xl text-center border-4 border-green-300 rounded-lg p-4 mb-4 focus:border-green-500 focus:outline-none"
                  placeholder="Your answer"
                  autoFocus
                />
                <button type="submit" className="w-full bg-green-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-green-700">
                  Submit Answer
                </button>
              </form>

              {feedback && (
                <div className={`mt-6 text-center text-xl font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WordProblemAdventure;